import { ArrowLeft, ArrowRight, FileWarning, MapPinOff } from "lucide-react";
import { Rule } from "./Ornament";

export const NoNodeState = ({ query, picks, onPick, onDraft, onBack, draftBlocked }) => (
  <section data-testid="no-node-state" className="max-w-2xl mx-auto px-4 sm:px-6 pt-10 pb-24 atlas-rise">
    <button data-testid="no-node-back-button" onClick={onBack} className="inline-flex items-center gap-1.5 text-sm text-muted-foreground hover:text-primary mb-8 transition-colors">
      <ArrowLeft className="h-4 w-4" /> Back
    </button>
    <span className="inline-grid place-items-center h-14 w-14 rounded-full border border-border bg-card text-muted-foreground mb-6">
      <MapPinOff className="h-6 w-6" strokeWidth={1.5} />
    </span>
    <Rule label="Not in the Atlas" className="max-w-xs mb-5" />
    <h2 className="font-display font-medium tracking-tight text-3xl sm:text-4xl leading-[1.05]">
      There is no catalog node for <span className="italic text-primary">“{query}”</span>.
    </h2>
    <p className="mt-4 text-base text-muted-foreground leading-relaxed">
      Atlas only charts routes through its mapped topics. The nearest ones are below — each is a real node with a
      deterministic prerequisite route.
    </p>

    <div className="mt-8 grid gap-2.5 sm:grid-cols-2" data-testid="nearest-picks">
      {picks.map((n) => (
        <button
          key={n.id}
          data-testid={`nearest-pick-${n.id}`}
          onClick={() => onPick(n)}
          className="card-ink text-left p-4 hover:border-primary/50 transition-colors group"
        >
          <span className="font-display text-lg leading-tight block group-hover:text-primary transition-colors">{n.name}</span>
          <span className="text-xs text-muted-foreground mt-1 block line-clamp-2">{n.desc}</span>
        </button>
      ))}
    </div>

    <div className="mt-10 card-ink border-dashed p-5 sm:p-6" data-testid="draft-offer">
      <div className="flex items-center gap-2">
        <FileWarning className="h-4 w-4 text-muted-foreground" />
        <span className="eyebrow text-muted-foreground">Draft · AI-generated · not in catalog</span>
      </div>
      <p className="mt-2 text-sm text-muted-foreground leading-relaxed">
        Atlas can ask an AI to sketch a route for “{query}”. It will be labelled DRAFT throughout, has no placement
        check, and is not part of the Atlas map. Use it as a sketch, not a syllabus.
      </p>
      <button
        data-testid="generate-draft-button"
        onClick={onDraft}
        disabled={draftBlocked}
        className="btn-ghost mt-4 disabled:opacity-50"
      >
        Generate a DRAFT route <ArrowRight className="h-4 w-4" />
      </button>
    </div>
  </section>
);
